export default __webpack_public_path__ + "static/media/maozinha.fb4a8fbf.png";